"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INTAKE_TOPIC_SOLUTIONS = exports.SOLUTION_DOMAIN_TOPICS = exports.SOLUTION_TOPICS = exports.TOPIC_SOLUTION_DOMAINS = exports.INTAKE_TOPICS_NL = exports.IntakeTopic = exports.TOPICS_NL = exports.Topic = void 0;
const solution_1 = require("./solution");
/** Also referred to as HouseTopic */
var Topic;
(function (Topic) {
    Topic["General"] = "general";
    Topic["PvSystem"] = "pvSystem";
    Topic["Walls"] = "walls";
    Topic["Floor"] = "floor";
    Topic["Roof"] = "roof";
    Topic["Windows"] = "windows";
    Topic["Heating"] = "heating";
    Topic["Other"] = "other";
})(Topic = exports.Topic || (exports.Topic = {}));
exports.TOPICS_NL = {
    general: 'Algemeen',
    pvSystem: 'Zonnepanelen',
    walls: 'Gevels',
    floor: 'Vloer',
    roof: 'Dak',
    windows: 'Glas',
    heating: 'Verwarming',
    other: 'Overig',
};
/** Identical to Topic except for Photos. Corresponds to the tabs in the intake tool in Energiebeheerders */
var IntakeTopic;
(function (IntakeTopic) {
    IntakeTopic["General"] = "general";
    IntakeTopic["PvSystem"] = "pvSystem";
    IntakeTopic["Walls"] = "walls";
    IntakeTopic["Floor"] = "floor";
    IntakeTopic["Roof"] = "roof";
    IntakeTopic["Windows"] = "windows";
    IntakeTopic["Heating"] = "heating";
    IntakeTopic["Other"] = "other";
    IntakeTopic["Photos"] = "photos";
})(IntakeTopic = exports.IntakeTopic || (exports.IntakeTopic = {}));
exports.INTAKE_TOPICS_NL = {
    general: 'Algemeen',
    pvSystem: 'Zonnepanelen',
    walls: 'Gevels',
    floor: 'Vloer',
    roof: 'Dak',
    windows: 'Glas',
    heating: 'Verwarming',
    other: 'Overig',
    photos: "Foto's",
};
exports.TOPIC_SOLUTION_DOMAINS = {
    general: [
        solution_1.SolutionDomain.PvSystem,
        solution_1.SolutionDomain.WallInsulation,
        solution_1.SolutionDomain.FloorInsulation,
        solution_1.SolutionDomain.RoofInsulation,
        solution_1.SolutionDomain.InsulationGlazing,
        solution_1.SolutionDomain.Heating,
    ],
    pvSystem: [solution_1.SolutionDomain.PvSystem],
    walls: [solution_1.SolutionDomain.WallInsulation],
    floor: [solution_1.SolutionDomain.FloorInsulation],
    roof: [solution_1.SolutionDomain.RoofInsulation, solution_1.SolutionDomain.PvSystem],
    windows: [solution_1.SolutionDomain.InsulationGlazing],
    heating: [solution_1.SolutionDomain.Heating],
    other: [solution_1.SolutionDomain.Miscellaneous],
};
exports.SOLUTION_TOPICS = {
    [solution_1.Solution.WallInsulation]: Topic.Walls,
    [solution_1.Solution.FloorInsulation]: Topic.Floor,
    [solution_1.Solution.CrawlspaceInsulation]: Topic.Floor,
    [solution_1.Solution.InnerRoofInsulation]: Topic.Roof,
    [solution_1.Solution.AtticFloorInsulation]: Topic.Roof,
    [solution_1.Solution.WindowGlazing]: Topic.Windows,
    [solution_1.Solution.WindowFrames]: Topic.Windows,
    [solution_1.Solution.PvSystem]: Topic.PvSystem,
    [solution_1.Solution.CentralHeatingBoiler]: Topic.Heating,
    [solution_1.Solution.HybridHeatPump]: Topic.Heating,
    [solution_1.Solution.ElectricHeatPump]: Topic.Heating,
    [solution_1.Solution.AirToAirHeatPump]: Topic.Heating,
    [solution_1.Solution.UnderfloorHeating]: Topic.Heating,
    [solution_1.Solution.Sedum]: Topic.Other,
    [solution_1.Solution.ChargingBox]: Topic.Other,
    [solution_1.Solution.HomeBattery]: Topic.Other,
};
exports.SOLUTION_DOMAIN_TOPICS = {
    wallInsulation: Topic.Walls,
    floorInsulation: Topic.Floor,
    roofInsulation: Topic.Roof,
    insulationGlazing: Topic.Windows,
    pvSystem: Topic.PvSystem,
    heating: Topic.Heating,
    miscellaneous: Topic.General,
};
exports.INTAKE_TOPIC_SOLUTIONS = {
    [IntakeTopic.Floor]: [solution_1.Solution.FloorInsulation, solution_1.Solution.CrawlspaceInsulation],
    [IntakeTopic.Walls]: [solution_1.Solution.WallInsulation],
    [IntakeTopic.Roof]: [solution_1.Solution.InnerRoofInsulation, solution_1.Solution.AtticFloorInsulation],
    [IntakeTopic.Windows]: [solution_1.Solution.WindowGlazing, solution_1.Solution.WindowFrames],
    [IntakeTopic.PvSystem]: [solution_1.Solution.PvSystem],
    [IntakeTopic.Heating]: [
        solution_1.Solution.CentralHeatingBoiler,
        solution_1.Solution.ElectricHeatPump,
        solution_1.Solution.HybridHeatPump,
        solution_1.Solution.AirToAirHeatPump,
        solution_1.Solution.UnderfloorHeating,
    ],
    [IntakeTopic.Other]: [solution_1.Solution.ChargingBox, solution_1.Solution.HomeBattery, solution_1.Solution.Sedum],
    [IntakeTopic.General]: [],
    [IntakeTopic.Photos]: [],
};
